import React from 'react';
import { CheckIcon, TrophyIcon } from 'lucide-react';
import { Highlight } from '../Highlight';
import { tomoIncludes, tomos } from '../../data/landing';
export function Tomos() {
  return <section className="bg-brand-soft px-5 py-16 md:py-24" data-id="element-254" data-mp="7wjeqqunaimx">
      <div className="mx-auto max-w-6xl" data-id="element-255" data-mp="7z5vnh3feaht">
        <div className="mx-auto max-w-3xl text-center" data-id="element-256" data-mp="cwpcmorid1dg">
          <TrophyIcon className="mx-auto h-10 w-10 text-gold-strong" aria-hidden="true" data-id="element-257" data-mp="cy8o8227yo8w" />
          <h2 className="mt-4 text-3xl font-black uppercase leading-[1.1] tracking-tight text-brand md:text-5xl" data-id="element-258" data-mp="3bfmioscdrgnb">
            MegaPack Colon Tranquilo <Highlight data-id="element-259" data-mp="3lc91zcp25zn8">en 7 Días™</Highlight>
          </h2>
          <p className="mt-5 text-xl font-bold text-charcoal" data-id="element-260" data-mp="3lao71lyu0eou">5 Tomos + 5 Bonos — Días 1 → 30</p>
          <p className="mt-1 text-lg text-muted" data-id="element-261" data-mp="3qcdiv3tvowdz">420+ páginas — Todo resuelto.</p>
        </div>

        <h3 className="mt-14 text-center text-sm font-bold uppercase tracking-[0.2em] text-brand" data-id="element-262" data-mp="10lgxev2rqhg7">
          5 Tomos completos
        </h3>

        <ol className="mt-8 space-y-4" data-id="element-263" data-mp="1hsifmoy2ib46">
          {tomos.map(t => <li key={t.number} className="grid grid-cols-[auto_1fr] items-center gap-5 rounded-3xl bg-white p-5 shadow-sm md:grid-cols-[auto_240px_1fr] md:gap-8 md:p-6" data-id="element-264" data-mp="1hqeeufvgts84">
              <span className="flex h-16 w-14 flex-col items-center justify-center rounded-lg text-white shadow-md md:h-20 md:w-16" style={{
            backgroundColor: t.color
          }} aria-hidden="true" data-id="element-265" data-mp="13szmb29x14bx">
                <span className="text-[10px] font-bold uppercase tracking-wider opacity-90" data-id="element-266" data-mp="u2ef4qg6erhe">Tomo</span>
                <span className="text-2xl font-black leading-none md:text-3xl" data-id="element-267" data-mp="p4mm1t3sozbm">{t.number}</span>
              </span>
              <div data-id="element-268" data-mp="l4ceic0cu0un">
                <p className="text-sm font-bold uppercase tracking-wider" style={{
              color: t.color
            }} data-id="element-269" data-mp="g3f10cqahuzh">
                  {t.days}
                </p>
                <p className="text-lg font-extrabold leading-tight text-brand md:text-xl" data-id="element-270" data-mp="b5mxsmk72mfz">
                  {t.title}
                </p>
              </div>
              <p className="col-span-2 text-base text-charcoal md:col-span-1" data-id="element-271" data-mp="6fsu2vutzvk6">{t.description}</p>
            </li>)}
        </ol>

        <div className="mt-10 rounded-3xl bg-brand p-7 md:p-10" data-id="element-272" data-mp="3nozch257fizg">
          <p className="text-xl font-extrabold text-white" data-id="element-273" data-mp="3smr55ydob94p">Cada tomo incluye:</p>
          <ul className="mt-5 grid gap-x-8 gap-y-3 sm:grid-cols-2" data-id="element-274" data-mp="3sou4j90puem3">
            {tomoIncludes.map(item => <li key={item} className="flex items-start gap-3 text-base text-white" data-id="element-275" data-mp="p60wfbqpihzb">
                <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-gold" data-id="element-276" data-mp="p8513vwfjl0n">
                  <CheckIcon className="h-3.5 w-3.5 text-brand" strokeWidth={3.5} aria-hidden="true" data-id="element-277" data-mp="fg7mef67qax6" />
                </span>
                {item}
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}